import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


const PrivacyPolicy = () => {
  return (
    <div className="container py-5" >
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <div className="card shadow-sm">
            <div className="card-body p-4 p-md-5">
              <h1 className="text-center mb-4">Privacy Policy</h1>
              <p className="text-muted text-center mb-4">Effective Date: 15/01/25</p>
              
              <div className="mb-5">
                <p className="lead">
                  At KLM Paper Bags, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website or interact with our services. By using our website, you agree to the terms of this Privacy Policy.
                </p>
              </div>

              <section className="mb-5">
                <h2 className="h3 mb-4">1. Information We Collect</h2>
                
                <div className="ms-4">
                  <h3 className="h5 mb-3">1.1 Personal Information</h3>
                  <p className="mb-3">We may collect personal information that you provide to us voluntarily, including but not limited to:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• Name</li>
                    <li className="mb-2">• Email address</li>
                    <li className="mb-2">• Phone number</li>
                    <li className="mb-2">• Shipping and billing address</li>
                    <li className="mb-2">• Payment information</li>
                  </ul>

                  <h3 className="h5 mb-3">1.2 Non-Personal Information</h3>
                  <p className="mb-3">We may also collect non-personal information automatically when you visit our website, such as:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• IP address</li>
                    <li className="mb-2">• Browser type and version</li>
                    <li className="mb-2">• Operating system</li>
                    <li className="mb-2">• Pages viewed and time spent on the website</li>
                    <li className="mb-2">• Referring website or source</li>
                  </ul>

                  <h3 className="h5 mb-3">1.3 Cookies</h3>
                  <p>We use cookies and similar tracking technologies to enhance your browsing experience. Cookies help us understand your preferences, improve website functionality, and provide targeted advertisements.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">2. How We Use Your Information</h2>
                
                <div className="ms-4">
                  <h3 className="h5 mb-3">2.1 Personal Information</h3>
                  <p className="mb-3">We use the personal information you provide to:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• Process and fulfill your orders</li>
                    <li className="mb-2">• Communicate with you about your orders and inquiries</li>
                    <li className="mb-2">• Provide customer support</li>
                    <li className="mb-2">• Send promotional offers and updates (only if you opt-in)</li>
                  </ul>

                  <h3 className="h5 mb-3">2.2 Non-Personal Information</h3>
                  <p className="mb-3">Non-personal information is used to:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• Analyze website traffic and user behavior</li>
                    <li className="mb-2">• Improve website functionality and design</li>
                    <li className="mb-2">• Detect and prevent fraudulent or unauthorized activities</li>
                  </ul>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">3. Sharing Your Information</h2>
                
                <div className="ms-4">
                  <h3 className="h5 mb-3">3.1 Third-Party Service Providers</h3>
                  <p className="mb-3">We may share your information with trusted third-party service providers to:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• Process payments securely</li>
                    <li className="mb-2">• Deliver products to your address</li>
                    <li className="mb-2">• Send email communications</li>
                  </ul>

                  <h3 className="h5 mb-3">3.2 Legal Obligations</h3>
                  <p className="mb-3">We may disclose your information if required to do so by law or if such disclosure is necessary to:</p>
                  <ul className="list-unstyled ms-4 mb-4">
                    <li className="mb-2">• Comply with legal obligations</li>
                    <li className="mb-2">• Protect the rights, safety, or property of KLM Paper Bags or others</li>
                  </ul>

                  <h3 className="h5 mb-3">3.3 Business Transfers</h3>
                  <p>In the event of a merger, acquisition, or sale of all or a portion of our assets, your personal information may be transferred to the new entity.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">4. Data Security</h2>
                
                <div className="ms-4">
                  <p>We implement appropriate technical and organizational measures to safeguard your personal information from unauthorized access, alteration, disclosure, or destruction. However, no online platform is 100% secure, and we cannot guarantee absolute security.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">5. Your Choices</h2>
                
                <div className="ms-4">
                  <h3 className="h5 mb-3">5.1 Access and Correction</h3>
                  <p className="mb-4">You have the right to access, update, or correct your personal information. Contact us if you wish to make any changes.</p>

                  <h3 className="h5 mb-3">5.2 Opt-Out</h3>
                  <p className="mb-4">You can opt out of receiving promotional emails by following the "unsubscribe" link in our communications. Please note that you may still receive transactional emails related to your orders.</p>

                  <h3 className="h5 mb-3">5.3 Cookie Preferences</h3>
                  <p>Most web browsers allow you to manage cookies through their settings. Disabling cookies may impact your user experience on our website.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">6. Third-Party Links</h2>
                
                <div className="ms-4">
                  <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites, and we encourage you to read their privacy policies.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">7. Children's Privacy</h2>
                
                <div className="ms-4">
                  <p>Our website is not intended for children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with their information, please contact us to have it removed.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">8. Changes to This Privacy Policy</h2>
                
                <div className="ms-4">
                  <p>We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page, and the "Effective Date" will be updated accordingly. Your continued use of our website constitutes acceptance of the updated policy.</p>
                </div>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">9. Contact Us</h2>
                
                <div className="ms-4">
                  <p className="mb-3">If you have any questions or concerns about this Privacy Policy or how we handle your information, please contact us:</p>
                  <ul className="list-unstyled ms-4">
                    <li className="mb-2">• Email: info@klmpaperbags.com</li>
                    <li className="mb-2">• Phone: [Insert Phone Number]</li>
                    <li className="mb-2">• Address: [Insert Company Address]</li>
                  </ul>
                </div>
              </section>

              <div className="text-center mt-5">
                <p className="text-muted">
                  Thank you for trusting KLM Paper Bags with your personal information. We value your privacy and are committed to protecting it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;